import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`network-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-wrapper">
        <a href="/" className="network-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_heath-wellbeing/artifacts/y6t91wic_heathandwellbeinglogogreen.png" 
            alt="HEATH & Wellbeing - HEALth in your WELLtth" 
            className="logo-image"
          />
        </a>
        
        <nav className={`network-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <button onClick={() => scrollToSection('about')} className="network-nav-link">
            About
          </button>
          <button onClick={() => scrollToSection('services')} className="network-nav-link">
            Services
          </button>
          <button onClick={() => scrollToSection('testimonials')} className="network-nav-link">
            Testimonials
          </button>
          <button onClick={() => scrollToSection('contact')} className="network-nav-link">
            Contact
          </button>
          <a 
            href="https://wa.me/61478694929"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary btn-nav"
          >
            Book a Call
          </a>
        </nav>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
